import { money } from "../../../lib/closing";

export const fmtBizDate = (d) => {
  const [y, m, day] = d.split("-").map(Number);
  return new Date(y, m - 1, day).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric", year: "numeric" });
};

// diffCents: accounted − total sale (positive = over)
export const matchLabel = (diffCents) =>
  diffCents === 0 ? "MATCHED" : `${diffCents > 0 ? "OVER" : "SHORT"} ${money(Math.abs(diffCents) / 100)}`;

export const StatusChip = ({ rec }) => {
  const diff = rec ? Math.round((rec.difference || 0) * 100) : null;
  const [label, cls] = !rec ? ["PENDING", "bg-amber-100 text-amber-800 border-amber-300"]
    : diff === 0 ? ["MATCHED", "bg-green-100 text-green-800 border-green-300"]
    : [matchLabel(diff), "bg-red-100 text-red-800 border-red-300"];
  return <span className={`text-[10px] font-bold uppercase tracking-[0.12em] px-2 py-0.5 rounded-sm border whitespace-nowrap ${cls}`} data-testid="closing-status-chip">{label}</span>;
};
